export default __webpack_public_path__ + "static/media/about-main.ed013784.jpg";